<div class="flex flex-col items-center justify-center w-full h-full page-wrap">
  <div class="flex size-font-weight-regular items-center justify-center error-icon">
    <img src="/svgs/global-error-icon.svg" alt="error icon" />
  </div>
  <div class="my-100-rem flex flex-col items-center justify-center space-y-025-rem">
    <h1 class="text-headline-sm-weight-semibold text-[1.25rem]">Page not found - Error 404</h1>
    <p class="text-body-md-weight-regular text-[0.875rem] text-center">
      The page you’re looking for doesn’t exist or has been moved.
    </p>
  </div>

  <button mat-flat-button color="primary" (click)="navigateToAllDevices()">Go to Devices</button>
</div>
